"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authMachine = exports.AuthMachineStates = void 0;
const xstate_1 = require("xstate");
const model_1 = require("xstate/lib/model");
const auth_failed_1 = require("./services/auth-failed");
const loading_1 = require("./services/loading");
const set_auth_data_1 = require("./services/set-auth-data");
const utils_1 = __importDefault(require("./utils"));
var AuthMachineStates;
(function (AuthMachineStates) {
    AuthMachineStates["LOADING"] = "loading";
    AuthMachineStates["AUTH_READY"] = "authReady";
    AuthMachineStates["FORCING_SIGN_IN"] = "forcingSignIn";
    AuthMachineStates["FAILED"] = "failed";
    AuthMachineStates["PROVIDING_AUTH_DATA"] = "providingAuthData";
})(AuthMachineStates = exports.AuthMachineStates || (exports.AuthMachineStates = {}));
const authModel = (0, model_1.createModel)({
    ssoHost: undefined,
    redirectTo: undefined,
    apolloClient: undefined,
    forceAuthentication: true,
    consumer: undefined,
}, {
    events: {
        authLoadingSuccessEvent: () => ({}),
        forceSignInEvent: () => ({}),
        dataSavedEvent: () => ({}),
        authFailedEvent: () => ({}),
        forceAuthEvent: () => ({}),
    },
});
const forceAuth = (0, xstate_1.assign)({
    forceAuthentication: true,
});
exports.authMachine = authModel.createMachine({
    predictableActionArguments: true,
    id: "authMachine",
    initial: AuthMachineStates.LOADING,
    states: {
        [AuthMachineStates.LOADING]: {
            invoke: {
                src: "authLoading",
            },
            on: {
                authLoadingSuccessEvent: {
                    target: AuthMachineStates.PROVIDING_AUTH_DATA,
                },
                forceSignInEvent: {
                    // This event is here for testing purposes
                    target: AuthMachineStates.FORCING_SIGN_IN,
                },
                authFailedEvent: {
                    target: AuthMachineStates.FAILED,
                },
            },
        },
        [AuthMachineStates.PROVIDING_AUTH_DATA]: {
            invoke: {
                src: "setAuthData",
            },
            on: {
                dataSavedEvent: {
                    target: AuthMachineStates.AUTH_READY,
                },
                authFailedEvent: {
                    target: AuthMachineStates.FAILED,
                },
            },
        },
        [AuthMachineStates.AUTH_READY]: {
            on: {
                authFailedEvent: {
                    target: AuthMachineStates.FAILED,
                },
                forceSignInEvent: {
                    target: AuthMachineStates.FORCING_SIGN_IN,
                },
            },
        },
        [AuthMachineStates.FORCING_SIGN_IN]: {
            invoke: {
                id: "redirect",
                src: (context) => new Promise((resolve, reject) => {
                    const snapAuthUpdatedEvent = new CustomEvent("SNAP_AUTH_UPDATED", { detail: "forcingSignIn" });
                    window.dispatchEvent(snapAuthUpdatedEvent);
                    const now = new Date().getTime();
                    const loopCheck = localStorage.getItem("loopCheck");
                    if (loopCheck) {
                        const lastLoad = new Date(parseInt(loopCheck)).getTime();
                        if (now - lastLoad < 1000) {
                            const error = new Error("Possible auth loop detected");
                            console.error(error);
                            return reject(error);
                        }
                    }
                    if (context.ssoHost &&
                        context.redirectTo &&
                        context.forceAuthentication) {
                        localStorage.setItem("loopCheck", now.toString());
                        return resolve(utils_1.default.forceRedirect(context.ssoHost, context.redirectTo, context.consumer));
                    }
                    let error;
                    if (context.forceAuthentication) {
                        error = new Error("Auth Machine: Please provide a SSO host and redirect to url in constructor");
                        console.error(error);
                    }
                    else {
                        error = new Error("Auth Machine: Not forcing authentication");
                        console.log("Not forcing authentication");
                    }
                    return reject(error);
                }),
                onDone: {
                    target: AuthMachineStates.FAILED,
                },
                onError: {
                    target: AuthMachineStates.FAILED,
                },
            },
        },
        [AuthMachineStates.FAILED]: {
            invoke: {
                src: "authFailed",
            },
            on: {
                forceAuthEvent: {
                    target: AuthMachineStates.FORCING_SIGN_IN,
                    actions: "forceAuth",
                },
            },
        },
    },
}, {
    services: {
        authLoading: loading_1.authLoading,
        setAuthData: set_auth_data_1.setAuthData,
        authFailed: auth_failed_1.authFailed,
    },
    actions: { forceAuth },
});
